/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CopyRelationshipItem/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import PermittedToSeeInfo from './PermittedToSeeInfo/index'
import PersonName from './PersonName/index'
import React from 'react'
import RelationshipType from './RelationshipType/index'
import Role from './Role/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CopyRelationshipItem({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/AddPersonRelation/Content/CopyRelationships/Content/Relationships/Content/CopyRelationshipItem"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="CopyRelationshipItem.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-1MIlWU': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="CopyRelationshipItem.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PersonName
  viewPath={`${viewPath}/PersonName`}
/>
</div>
<div
  data-testid="CopyRelationshipItem.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<RelationshipType
  viewPath={`${viewPath}/RelationshipType`}
/>
<Role
  viewPath={`${viewPath}/Role`}
/>
<PermittedToSeeInfo
  viewPath={`${viewPath}/PermittedToSeeInfo`}
/>
</div>
</div>
{children}
</React.Fragment>)
}